import PropTypes from "prop-types";
import styles from "./KycStatus.module.css";
import store from "../../../Store/Store";
import companyStore from "../../../Store/Store";
import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
import config from "../../../config/config";
import axios from "axios";

const KycStatus = ({ isVisible, onClose, className = "" }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [PhoneNo, setPhoneNo] = useState();
  const [Txnlimt, setTxnlimt] = useState("");
  const [dailyLimit, setDailyLimit] = useState("");
  const [MonthlyLimit, setMonthlyLimit] = useState("");
  const [ErrorMessage, setErrorMessage] = useState("");
  const [AllTags, setAllTags] = useState([]);
  const [errormsg, setErrorMsg] = useState({
    isNameTooShort: false,
    isAnyFieldEmpty: false,
    isInvalidEmail: false,
    isTxnLimitNegative: false,
    isDailyLimitNegative: false,
    isMonthlyLimitNegative: false,
    isTxnLimitExceeds: false,
    isDailyLimitExceedsMonthly: false,
    isEmailExists: false,
  });
  const onFrameButtonClick = () => {
    setErrorMsg({
      isNameTooShort: false,
      isAnyFieldEmpty: false,
      isInvalidEmail: false,
      isTxnLimitNegative: false,
      isDailyLimitNegative: false,
      isMonthlyLimitNegative: false,
      isTxnLimitExceeds: false,
      isDailyLimitExceedsMonthly: false,
      isEmailExists: false,
    });
    if (
      name == "" ||
      email == "" ||
      Txnlimt == "" ||
      dailyLimit == "" ||
      MonthlyLimit == ""
    ) {
      console.log("error");

      setErrorMsg((prev) => ({ ...prev, isAnyFieldEmpty: true }));
      setErrorMessage("All Fields are required");
      return;
    }
    if (name.trim().length < 3) {
      setErrorMessage("Name Cannot be less that 3 character");
      console.log("hit");
      setErrorMsg((prev) => ({ ...prev, isNameTooShort: true }));
      return;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      setErrorMsg((prev) => ({ ...prev, isInvalidEmail: true }));
      setErrorMessage("Please enter a valid email address");
      return;
    }
    if (
      Number(dailyLimit) <= 0 ||
      Number(Txnlimt) <= 0 ||
      Number(MonthlyLimit) <= 0
    ) {
      if (Number(dailyLimit) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isDailyLimitNegative: true }));
      }
      if (Number(Txnlimt) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isTxnLimitNegative: true }));
      }
      if (Number(MonthlyLimit) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isMonthlyLimitNegative: true }));
      }
      setErrorMessage("Limits Cannot be 0");
      return;
    }
    if (
      Number(Txnlimt) > Number(dailyLimit) ||
      Number(Txnlimt) > Number(MonthlyLimit)
    ) {
      setErrorMsg((prev) => ({ ...prev, isTxnLimitExceeds: true }));
      setErrorMessage(
        "Transaction Limit should not be greater than dailyLimit or monthlyLimit"
      );
      return;
    }
    if (Number(dailyLimit) > Number(MonthlyLimit)) {
      setErrorMsg((prev) => ({ ...prev, isDailyLimitExceedsMonthly: true }));
      setErrorMessage("Daily Limit should not be greater than monthlyLimit");
      return;
    }
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);

    const obj1 = JSON.stringify({
      user_name: name.trim(),
      user_email: email.trim(),
      perTxnLimit: Number(Txnlimt),
      dailyLimit: Number(dailyLimit),
      monthlyLimit: Number(MonthlyLimit),
      ledger_label: store.Company_Id,
      roles: ["CUPI_COMPANY_EMPLOYEE", "ADMIN"],
      tags: AllTags.join(", "),
    });
    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/create_cupi_compnay_user`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj1,
    };
    axios
      .request(payload)
      .then((res) => {
        console.log(res.data.data.msg.message);
        if (res.data.data.msg.message.trim() == "User Already Exists :") {
          console.log("UserExist");
          setErrorMsg((prev) => ({ ...prev, isEmailExists: true }));
          setErrorMessage("Email Already Exists");
          return;
        }
        console.log("%o", res);
        onClose();
        openNoti();
      })
      .catch((err) => {
        console.log("%o", err);
      });
  };

  useEffect(() => {
    setName(store?.name);
    setEmail(store?.selectedEmail);
    setPhoneNo(store?.SelectedPhoneNo);

    setTxnlimt(store?.txnLimit);
    setDailyLimit(store?.DailyLimit);
    setMonthlyLimit(store?.MonthlyLimit);
    setAllTags(
      store.Tags ? store.Tags.split(",").filter((tag) => tag.trim() !== "") : []
    );
  }, []);

  if (!isVisible) return null;
  return (
    <div
      className={[styles.frameParent, className].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={styles.xCloseWrapper}
        onClick={() => {
          store.setDate("");
          store.setPaidTo("");
          store.setPurpose("");
          store.setDebit("");
          store.setUPIId();
          store.setUtr("");
          store.setTxnId("");
          onClose();
        }}
      >
        <img className={styles.xCloseIcon} alt="" src="/xclose.svg" />
      </div>
      <div className={styles.frameGroup}>
        <div className={styles.transactionDetailsParent}>
          <div className={styles.transactionDetailshead}>KYC Request</div>
          <div className={styles.frameContainer}>
            <div className={styles.nameParent}>
              <div className={styles.name}>DATE</div>
              <div className={styles.nithinPrakash}>
                {store?.create_at || "-"}
              </div>
            </div>
            <div className={styles.nameParent}>
              <div className={styles.name}>NAME</div>
              <div className={styles.nithinPrakash}>{store.name}</div>
            </div>
            <div className={styles.nameParent}>
              <div className={styles.name}>USER PHONE NO</div>
              <div className={styles.nithinPrakash}>
                {store.SelectedPhoneNo || "-"}
              </div>
            </div>
            <div className={styles.nameParent}>
              <div className={styles.name}>USER EMAIL ID</div>
              <div className={styles.nithinPrakash}>
                {store?.selectedEmail || "-"}
              </div>
            </div>
            <div className={styles.nameParent}>
              <div className={styles.name}>STATUS</div>
              <div className={styles.nithinPrakash}>
                {store?.KYCStatus.toUpperCase() || "-"}
              </div>
            </div>
            {store.KYCStatus != "pending" && (
              <div className={styles.nameParent}>
                <div className={styles.name}>REASON</div>
                <div className={styles.nithinPrakash}>
                  {store?.kycRejectedReason || "-"}
                </div>
              </div>
            )}
            <div className={styles.nameParent1}>
              <div className={styles.name}>TAGS</div>
              <div className={styles.setTransactionOneTagContainer}>
                {AllTags.length > 0 &&
                  AllTags.map((data, index) => {
                    if (data == "" || data == null) {
                      return null;
                    }
                    return (
                      <div className={styles.setTransactionOneTag}>
                        {data.slice(0, 15)}
                        {data.length > 15 ? "..." : ""}

                        {/* <button
                            className={styles.setTransactionButton}
                            onClick={() => {
                              removeTag(data, index);
                            }}
                          >
                            <img
                              className={styles.arrowNarrowLeftIcon12}
                              alt=""
                              src="/Close.svg"
                            />
                          </button> */}
                      </div>
                    );
                  })}
                {AllTags.length == 0 && (
                  <div className={styles.mobileMenuele2}>
                    No tags available.
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.frameContainerhead}>Transaction Limits</div>
          <div className={styles.frameContainer}>
            <div className={styles.nameParent}>
              <div className={styles.name}>TXN LIMIT</div>
              <div className={styles.nithinPrakash}>
                {store?.txnLimit || "-"}
              </div>
            </div>

            <div className={styles.nameParent}>
              <div className={styles.name}>DAILY</div>
              <div className={styles.nithinPrakash}>
                {store?.DailyLimit || "-"}
              </div>
            </div>

            <div className={styles.nameParent}>
              <div className={styles.name}>MONTHLY</div>
              <div className={styles.nithinPrakash}>
                {store?.MonthlyLimit || "-"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.finalCupiLogo}>
        <img className={styles.escrowLogo} alt="" src="/PineLabsLogo.svg" />
      </div>
    </div>
  );
};

KycStatus.propTypes = {
  className: PropTypes.string,
};

export default KycStatus;
